import React from "react";
import { Box, Paper, Typography, useTheme } from "@mui/material";

const StatsCard = ({ title, value, delta, deltaText, icon, color, onClick }) => {
  const theme = useTheme();
  const isPositive = delta >= 0;

  return (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 3,
        m: 1,
        // height: "100%",
        borderRadius: "16px",
        boxShadow: "0px 2px 10px rgba(0,0,0,0.05)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
        overflow: "hidden",
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick ? { boxShadow: "0px 4px 15px rgba(0,0,0,0.1)" } : {},
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: 16 }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "12px",
            backgroundColor: `${color}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: color,
          }}
        >
          {icon}
        </Box>
      </Box>

      <Box>
        <Typography
          variant="h3"
          sx={{ fontWeight: 800, fontSize: "3.75rem", color: "#2d3436" }}
        >
          {value}
        </Typography>
        {/* <Typography
          variant="caption"
          sx={{
            color: isPositive
              ? theme.palette.success.main
              : theme.palette.error.main,
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
            fontSize: "0.85rem",
          }}
        >
          {isPositive ? "+" : ""}
          {delta}% {deltaText}
        </Typography> */}
      </Box>
    </Paper>
  );
};

export default StatsCard;
